__turbopack_context__.v({
  "loginButton": "askAiTooltip-module-scss-module__JWOH3W__loginButton",
  "noAccessContainer": "askAiTooltip-module-scss-module__JWOH3W__noAccessContainer",
  "noAccessDescription": "askAiTooltip-module-scss-module__JWOH3W__noAccessDescription",
});
